import { Location } from "react-router-dom"

export enum EPath {
    HOME = '',
    
    // Review
    REVIEW = '/review',
    REVIEW_DETAIL = '/review/:id',
    REVIEW_COPILOT = '/review/:id/copilot',
    REVIEW_ANONYMISATION = '/review/:id/anonymisation',
    
    // Drafting
    TEMPLATE = '/template',
    TEMPLATE_CREATE = '/template/create',
    TEMPLATE_DETAIL = '/template/:id',
    TEMPLATE_ARCHIVE = '/archive/template',
    DRAFT = '/draft',
    DRAFT_CREATE = '/draft/create',
    DRAFT_DETAIL = '/draft/:id',
    DRAFT_ARCHIVE = '/archive/draft',
    
    // Discovery
    DISCOVERY = '/discovery',
    DISCOVERY_CHAT = '/discovery/:id',
    
    // Training
    TRAINING = '/training',
    
    // Settings
    SETTINGS = '/settings',
    SETTINGS_SUBSCRIPTION = '/settings/subscription',
    SETTINGS_INVOICES = '/settings/invoices',
    SETTINGS_USERS = '/settings/users',

    // Sandboxes
    SNIPER = '/sandbox/sniper',
}

export class Paths {
    static HOME = () => Paths.buildPath(EPath.HOME);

    // Review
    static REVIEW = () => Paths.buildPath(EPath.REVIEW);
    static REVIEW_COPILOT = (params: { id: string }) => Paths.buildPath(EPath.REVIEW_COPILOT, params);
    static REVIEW_DETAIL = (params: { id: string }) => Paths.buildPath(EPath.REVIEW_DETAIL, params);
    static REVIEW_ANONYMISATION = (params: { id: string }) => Paths.buildPath(EPath.REVIEW_ANONYMISATION, params);

    // Drafting
    static DRAFT = () => Paths.buildPath(EPath.DRAFT);
    static DRAFT_CREATE = () => Paths.buildPath(EPath.DRAFT_CREATE);
    static DRAFT_DETAIL = (params: { id: string }) => Paths.buildPath(EPath.DRAFT_DETAIL, params);
    static DRAFT_ARCHIVE = () => Paths.buildPath(EPath.DRAFT_ARCHIVE);
    static TEMPLATE = () => Paths.buildPath(EPath.TEMPLATE);
    static TEMPLATE_CREATE = () => Paths.buildPath(EPath.TEMPLATE_CREATE);
    static TEMPLATE_DETAIL = (params: { id: string }) => Paths.buildPath(EPath.TEMPLATE_DETAIL, params);
    static TEMPLATE_ARCHIVE = () => Paths.buildPath(EPath.TEMPLATE_ARCHIVE);
    static DISCOVERY = () => Paths.buildPath(EPath.DISCOVERY);
    static DISCOVERY_CHAT = (params: { id: string }) => Paths.buildPath(EPath.DISCOVERY_CHAT, params);

    // Training
    static TRAINING = () => Paths.buildPath(EPath.TRAINING);

    // Settings
    static SETTINGS = () => Paths.buildPath(EPath.SETTINGS);
    static SETTINGS_SUBSCRIPTION = () => Paths.buildPath(EPath.SETTINGS_SUBSCRIPTION);
    static SETTINGS_INVOICES = () => Paths.buildPath(EPath.SETTINGS_INVOICES);
    static SETTINGS_USERS = () => Paths.buildPath(EPath.SETTINGS_USERS);

    // Sandboxes
    static SNIPER = () => Paths.buildPath(EPath.SNIPER);

    private static buildPath(template: string, params?: Record<string, number | string>): string {
        if (!params) return template;

        Object.entries(params).forEach(([key, value]) => {
            template = template.replace(`:${key}`, String(value));
        });
        return template;
    }

    public static isActivePath = (location: Location, path: EPath | EPath[]): boolean => {
        const normalizePath = (p: EPath) => p.replace(/:\w+/g, '[^/]+'); // Replace dynamic segments like :id with [^/]+ (any character except /)
        
        if (Array.isArray(path)) {
            return path.some(p => {
                const regex = new RegExp(`^${normalizePath(p)}$`); // Create a regex for each path
                return regex.test(location.pathname);
            });
        } else {
            const regex = new RegExp(`^${normalizePath(path)}$`); // Create a regex for the single path
            return regex.test(location.pathname);
        }
    }

    public static isActiveRootPath = (location: Location, path: EPath | EPath[]): boolean => {
        const getRootPath = (pathname: string) => {
            const matches = pathname.match(/^\/[^\/]*/);
            return matches ? matches[0] : '/';
        };
    
        const normalizePath = (p: EPath) => {

            if(p === EPath.HOME) return '/';

            return `/${p.startsWith('/') ? p.slice(1) : p}`.replace(/\/$/, '');
        };
    
        const locationRootPath = getRootPath(location.pathname);
    
        if (Array.isArray(path)) {
            return path.some(p => locationRootPath === normalizePath(p));
        } else {
            return locationRootPath === normalizePath(path);
        }
    }
}
